module.exports = __webpack_public_path__ + "static/media/4.06fc0684.JPG";